import { useState, useEffect } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const TopSellingProductsTable = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const { data } = await axios.get('/api/v1/admin/dashboard/top-products', { params: { limit } });
                setProducts(data.products);
            } catch (error) {
                console.error('Failed to load top selling products', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [limit]);

    return (
        <div className="bg-white rounded-xl shadow-lg p-5 flex flex-col gap-4">
            <div className="flex justify-between items-center">
                <h2 className="font-medium text-lg">Top Selling Products</h2>
                <TextField
                    select
                    size="small"
                    label="Show"
                    value={limit}
                    onChange={(e) => setLimit(Number(e.target.value))}
                    sx={{ minWidth: 120 }}
                >
                    <MenuItem value={10}>Top 10</MenuItem>
                    <MenuItem value={15}>Top 15</MenuItem>
                    <MenuItem value={20}>Top 20</MenuItem>
                    <MenuItem value={25}>Top 25</MenuItem>
                </TextField>
            </div>

            {loading ? (
                <p className="text-sm text-gray-400">Loading...</p>
            ) : products.length === 0 ? (
                <p className="text-sm text-gray-400">No sales data yet.</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="text-left text-gray-500 border-b">
                                <th className="py-2 pr-2">#</th>
                                <th className="py-2 pr-2">Product</th>
                                <th className="py-2 pr-2 text-right">Units Sold</th>
                                <th className="py-2 text-right">Revenue</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map((p, i) => (
                                <tr key={p._id || i} className="border-b last:border-0">
                                    <td className="py-2 pr-2 text-gray-400">{i + 1}</td>
                                    <td className="py-2 pr-2 flex items-center gap-2">
                                        {p.image && <img src={p.image} alt={p.name} className="w-8 h-8 object-contain rounded" />}
                                        <span className="truncate max-w-xs">{p.name}</span>
                                    </td>
                                    <td className="py-2 pr-2 text-right">{p.unitsSold}</td>
                                    <td className="py-2 text-right font-medium">HK${p.revenue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default TopSellingProductsTable;